export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#B3F50D" },
        { className: "secondary-bg-colour", colour: "#27272A" },
        { className: "tertiary-bg-colour", colour: "#1C1C1C" },
        { className: "inactive-bg-colour", colour: "#141414" },
        { className: "misc-bg-colour", colour: "#4444441f" },
    ],
    text: [
        { className: "primary-text", colour: "#ffffff" },
        { className: "secondary-text", colour: "#191919" },
        { className: "tertiary-text", colour: "#ffffff" },
        { className: "inactive-text", colour: "#B6B6B6" },
        { className: "misc-text", colour: "#E60000" },
    ],
    // force primary-text to black on primary-bg-colour only :(
    contextualText: [
        { parentClassName: "primary-bg-colour", className: "primary-text", colour: "#000000", fontWeight: "700" },
    ],
    borders: [
        { className: "primary-border-colour", colour: "#E60000" },
        { className: "secondary-border-colour", colour: "#191919" },
        { className: "primary-free-border-colour", colour: "#44444440" },
    ],
};

